// components/ApplyButton.jsx

import { useEffect, useState } from "react";
import { MdCheckCircle } from "react-icons/md";
import { baseurl } from "../Url";
import style from "./Opportunities.module.css";


const ApplyButton = ({ vacancyId, initiallyApplied = false, isExpired = false, onSuccess, onBeforeApply }) => {
  const [isApplied, setIsApplied] = useState(initiallyApplied);
  const [isApplying, setIsApplying] = useState(false);

  useEffect(() => {
    setIsApplied(initiallyApplied);
  }, [initiallyApplied]);

  const handleApply = async () => {
    const memberId = localStorage.getItem("USERID");

    if (!memberId) {
      alert("Please login to apply");
      return;
    }

    if (isApplied) {
      alert("Already applied");
      return;
    }

    if (isExpired) {
      alert("This job posting has expired.");
      return;
    }

    if (onBeforeApply) {
      try {
        await onBeforeApply();
      } catch {
        return;
      }
    }

    setIsApplying(true);

    try {
      const response = await fetch(`${baseurl}/vacancies/apply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          vacancy_id: vacancyId,
          member_id: memberId,
        }),
      });

      const data = await response.json();

      if (data.status === "success") {
        setIsApplied(true);
        if (onSuccess) onSuccess(vacancyId);
      } else {
        alert(data.message || "Failed to apply");
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    } finally {
      setIsApplying(false);
    }
  };

  return (
    <button
      className={`${style.actionBtn} ${isApplied ? style.appliedBtn : ""} ${!isApplied && isExpired ? style.expiredBtn : ""}`}
      onClick={handleApply}
      disabled={isApplied || isApplying || isExpired}
    >
      <MdCheckCircle />
      <span>
        {isApplying ? "Applying..." : isApplied ? "Applied" : isExpired ? "Expired" : "Apply"}
      </span>
    </button>
  );
};

export default ApplyButton;